import type { Segment } from '@netpurpose/types'
import type { Segment as BackendSegment } from '../../generated/facts'

export const parseSegment = (segment: BackendSegment): Segment => ({
  id: segment.segment_id,
  name: `${segment.segment_category}:${segment.segment_class}:${segment.segment_instance}`,
  category: segment.segment_category,
  class: segment.segment_class,
  instance: segment.segment_instance,
})
